import {
    IDocumentUploadTemplateData,
} from 'store/slices/document-upload-template/document-upload-template-slice-type';

export const convertDocumentUploadTemplateData = (
    data?: Partial<IDocumentUploadTemplateData>,
): Partial<IDocumentUploadTemplateData> => ({
    ...data,
    documentTypesCodes: data?.documentTypes?.map(document => document?.docTypeCode) || [],
}) as Partial<IDocumentUploadTemplateData>;
